// Empty-panel starter chips (docs/06 §3; UX audit P1-1). Three one-tap prompts grounded in
// the org's real data — the first screen and first playlist by name — so the very first
// message costs nothing to compose. Falls back to generic wording when the org has no
// screens/playlists yet. Plus a one-line explainer of the undo/confirm semantics so a
// first-time user knows what "Apply" and "Undo" mean before they send anything.

import { useScreens } from '../api/screens.ts';
import { usePlaylists } from '../api/playlists.ts';

export function StarterChips({ onPick }: { onPick: (text: string) => void }) {
  const screens = useScreens();
  const playlists = usePlaylists();

  const firstScreen = screens.data?.[0]?.name;
  const firstPlaylist = playlists.data?.[0]?.name;

  const chips: string[] = [
    "Make a slide: this week's special",
    firstScreen ? `What's playing on ${firstScreen} right now?` : "What's playing right now?",
    firstPlaylist
      ? `Schedule ${firstPlaylist} on all screens tonight`
      : 'Schedule a playlist on all screens tonight',
  ];

  return (
    <div className="asst-starters">
      <div className="asst-starter-chips">
        {chips.map((c) => (
          <button key={c} type="button" className="asst-chip" onClick={() => onPick(c)}>
            {c}
          </button>
        ))}
      </div>
      <p className="asst-starter-note text-dim">
        I apply small edits (like a price change) instantly — you can undo them. Bigger or bulk
        changes I show you first to confirm before anything goes live.
      </p>
    </div>
  );
}
